






import CommonBase from "../CommonBase";
import {CardUserdata, Company} from "../../modules/models";
import {Component, Prop} from "vue-property-decorator";

@Component
export default class SuperSheet extends CommonBase{
    @Prop({default: null})
    user!: CardUserdata | null;

    @Prop({default: null})
    companyOrgNum!: number | null;

    @Prop({type: Boolean, default: false})
    outline!: boolean;

    get isSuper() {
        if(this.companyOrgNum && this.user) {
            return this.user.isCompanySuper(this.companyOrgNum);
        }
        return false;
    }

}
